<template>
	<header class="Header">
		<div class="wrapper">
			<div
				class="Header_row d-flex justify-space-between align-center gap-30"
			>
				<a
					class="Header_logo"
					href="https://www.venuelocity.com/"
					target="_blank"
				>
					<img
						:src="require('@/assets/img/logo-login1.svg')"
						alt="Dashboard logo"
					/>
				</a>

				<div class="flex-grow-1">
					<div class="Header_name">{{ getSiteName() }}</div>
					<div class="Header_title text-h4">{{ title }}</div>
				</div>

				<div class="Header_control">
					<div class="d-flex align-start gap-10">
						<!-- <select class="Header_portal" v-model="site_selected" @change="changePortal" v-if="sites.length>1">
                <option v-for="(site,key) in sites" :value="site.site_id" :key="key">{{ getLabelSite(site.property_type) }}</option>
              </select> -->

						<div class="Header_dates">
							<v-card>
								<v-menu
									ref="pickerMenu"
									v-model="pickerMenu"
									transition="scale-transition"
									offset-y
									min-width="auto"
									:close-on-content-click="false"
									:return-value.sync="dates"
								>
									<template v-slot:activator="{ on, attrs }">
										<div class="d-flex align-center gap-10">
											<div
												class="d-flex align-center gap-10"
											>
												<img
													class="Header_dates-icon"
													src="../assets/img/icon-calendar1.svg"
													alt="icon calendar"
												/>
												<label
													class="Header_dates-label"
													for="header_dates"
													>Date Range</label
												>
											</div>
											<input
												class="Header_dates-field"
												id="header_dates"
												v-model="dateRangeText"
												v-bind="attrs"
												v-on="on"
												readonly
											/>
										</div>
									</template>
									<v-date-picker
										v-model="dates"
										:min="mindate"
										:max="maxdate"
										no-title
										scrollable
										range
									>
										<v-btn
											color="primary"
											@click="handleCancel"
											text
											>Cancel</v-btn
										>
										<v-btn
											color="primary"
											@click="getLeadsByDates"
											text
											>OK</v-btn
										>
									</v-date-picker>
								</v-menu>
							</v-card>

							<div class="d-flex gap-10 justify-end mt-2">
								<button
									@click="() => handlePresetClick()"
									:class="[
										'Header_dates-preset',
										rangeLength === allTimeRangeLength
											? 'active'
											: '',
									]"
								>
									All Time
								</button>
								<button
									v-for="preset in [1, 15, 30, 60]"
									@click="() => handlePresetClick(preset)"
									:class="[
										'Header_dates-preset',
										rangeLength === preset ? 'active' : '',
									]"
									:key="preset"
								>
									{{ preset }}
									{{ preset > 1 ? "Days" : "Day" }}
								</button>
							</div>
						</div>

						<download-csv
							:data="dataCSV"
							:name="fileName"
							:labels="fileHeaders"
							class="Header_download mt-3 ml-3"
						>
							<img
								class="mr-1"
								src="@/assets/img/icon-download1.svg"
								alt="Header Download Icon"
							/>
							<span>Export Leads</span>
						</download-csv>

						<hr class="vr mt-2" />

						<v-menu bottom left offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on">
									<img
										src="@/assets/img/icon-user1.svg"
										alt="Header User Icon"
									/>
								</v-btn>
							</template>

							<v-list>
								<v-list-item v-if="total_properties > 1">
									<router-link
										class="link"
										to="/select-property"
										>Select another Property</router-link
									>
								</v-list-item>

								<v-list-item
									v-for="(site, key) in sites"
									:key="key"
									v-if="
										parseInt(site.property_type) !==
										propertyType
									"
								>
									<a
										class="link"
										@click.prevent="
											() =>
												handlePropertyTypeClick({
													name: 'Dashboard',
													params: {
														siteId: site.site_id,
														propertyType:
															site.property_type,
														startDate: dates[0],
														endDate: dates[1],
													},
												})
										"
										>{{
											getLabelSite(site.property_type)
										}}</a
									>
								</v-list-item>

								<v-list-item v-if="total_properties > 1">
									<a
										class="link"
										@click.stop="notiPrefModal = true"
									>
										Notification Preferences
									</a>
								</v-list-item>

								<v-list-item>
									<v-btn
										block
										small
										color="primary"
										@click.prevent="logOutHandler"
									>
										<span>Log Out</span>
										<img
											class="ml-2"
											src="@/assets/img/icon-logout2.svg"
											alt="icon logout"
										/>
									</v-btn>
								</v-list-item>
							</v-list>
						</v-menu>
					</div>
				</div>
			</div>
		</div>

		<v-dialog v-model="notiPrefModal" width="420" persistent>
			<v-card>
				<v-card-title class="primary--text">
					Notification Preferences
				</v-card-title>
				<v-card-text>
					<p>
						Please, select your preferred frequency for receiving
						email notifications.
					</p>
					<v-checkbox
						v-for="item in ['instant', 'weekly', 'monthly']"
						v-model="notiPrefState[item]"
						:key="item"
						:label="toCapitalized(item)"
						hide-details
					/>
					<!--<p v-if="notiPrefUnsubscribed" class="mt-5">You are <strong>unsubscribed</strong> from All Emails</p>-->
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						color="red darken-1"
						@click="handleNotiPrefCancel"
						text
					>
						Cancel
					</v-btn>
					<v-btn
						color="primary"
						:disabled="notiPrefCTA.disabled"
						@click="handleNotiPrefConfirm"
					>
						{{ notiPrefCTA.label }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</header>
</template>

<script>
import * as dayjs from "dayjs";
import JsonCSV from "vue-json-csv";

import { EventBus } from "@/utilities";
import {
	BUS_EVENTS,
	// FILE_HEADERS,
	PROPERTIES_TYPES,
	LEAD_TYPES,
} from "@/constants";

import { mapGetters, mapActions } from "vuex";
import { RouterLink } from "vue-router";

export default {
	name: "Header",
	components: {
		RouterLink,
		"download-csv": JsonCSV,
	},
	props: {
		title: {
			type: String,
			default: "",
		},
		leads: {
			type: Array,
			default: [],
		},
		leadsOutbound: {
			type: Array,
			default: [],
		},
		parent_dates: {
			type: Array,
			default: [
				dayjs().subtract(30, "day").format("YYYY-MM-DD"),
				dayjs().format("YYYY-MM-DD"),
			],
		},
		sites: {
			type: Array,
			default: [],
		},
		propertyType: {
			type: Number,
			default: 0,
		},
		leadType: {
			type: String,
		},
	},
	data() {
		return {
			emailPreferences: {
				instant: false,
				weekly: false,
				monthly: false,
			},
			notiPrefState: {
				instant: false,
				weekly: false,
				monthly: false,
			},
			notiPrefModal: false,
			notiPrefCTA: {
				label: "Confirm Changes",
				disabled: false,
			},
			pickerMenu: false,
			userMenu: false,
			// presetAllDatesActive: false,
			maxdate: dayjs().format("YYYY-MM-DD"),
			dates: [],
			// fileHeaders: FILE_HEADERS,
		};
	},
	beforeMount() {
		this.dates = this.parent_dates;

		this.getNotification().then((dataNotStates) => {
			Object.entries(dataNotStates).forEach(([key, value]) => {
				this.emailPreferences[key] = value;
				this.notiPrefState[key] = value;
			});
		});
	},
	computed: {
		...mapGetters({
			total_properties: "StateTotalProperties",
			store_site_id: "StateSiteSeleted",
			store_sites: "StateSites",
			store_user: "StateUser",
		}),

		notiPrefUnsubscribed() {
			return Object.values(this.notiPrefState).every(
				(value) => value === false
			);
		},

		firstDate() {
			const localFirstDate = this.store_sites.find(
				(site) => site.site_id === this.store_site_id
			).launch_date;
			return localFirstDate === "0000-00-00"
				? "2023-06-01"
				: dayjs(localFirstDate).format("YYYY-MM-DD");
		},
		lastDate() {
			return new dayjs().format("YYYY-MM-DD");
		},

		fileHeaders() {
			let flatKeys = [];
			if (this.leadType === LEAD_TYPES.INBOUND)
				flatKeys = this.leads.map((lead) => Object.keys(lead)).flat();
			else
				flatKeys = this.leadsOutbound
					.map((lead) => Object.keys(lead))
					.flat();

			const formattedEntries = [...new Set(flatKeys)].map((key) => [
				key,
				key.replaceAll("_", " "),
			]);

			return Object.fromEntries(formattedEntries);
		},
		mindate() {
			return this.firstDate === null || this.firstDate === "0000-00-00"
				? "2023-06-01"
				: dayjs(this.firstDate).format("YYYY-MM-DD");
		},
		dateRangeText() {
			const formattedDates = this.dates.map((date) =>
				dayjs(date).format("MM/DD/YYYY")
			);
			return formattedDates.join(" - ");
		},
		site_selected: {
			get() {
				return this.$store.getters.StateSiteSeleted;
			},
			set(value) {
				this.$store.commit("setSiteSelected", value);
			},
		},
		fileName() {
			if (this.leadType === LEAD_TYPES.INBOUND)
				return `vlm-${dayjs().format("MMDDYYHHmmss")}.csv`;
			else return `vlm_outbound-${dayjs().format("MMDDYYHHmmss")}.csv`;
		},
		dataCSV() {
			let excludedKeys = [];
			if (this.leadType === LEAD_TYPES.INBOUND) {
				excludedKeys =
					this.propertyType === PROPERTIES_TYPES.WEDDINGS
						? [
								"company",
								"site",
								"custom_view",
								"sendto",
								"bcc",
								"emailcc",
								"property",
								"city",
								"state",
								"hotel_class",
								"footerForm-file_Url_0",
								"footerForm-file_txt",
								"homeForm-file_Url_0",
								"homeForm-file_txt",
								"i_agree",
								"id",
								"subscribe",
								"type",
								"name",
								"rooms_commission",
								"banquet_commission",
								"confirmation_id",
								"reference_id",
						  ]
						: [
								"site",
								"custom_view",
								"sendto",
								"bcc",
								"emailcc",
								"property",
								"city",
								"state",
								"hotel_class",
								"footerForm-file_Url_0",
								"footerForm-file_txt",
								"homeForm-file_Url_0",
								"homeForm-file_txt",
								"i_agree",
								"id",
								"subscribe",
								"type",
								"name",
								"rooms_commission",
								"banquet_commission",
								"confirmation_id",
								"reference_id",
						  ];
			} else {
				excludedKeys = [
					"type",
					"id",
					"method",
					"company_id",
					"visitor_id",
					"first_visit",
					"session_id",
					"company_country",
					"company_state",
					"company_city",
					"company_zip",
					"referer",
					"search_term",
					"first_page",
					"time_date",
					"current_page_request_count",
					"fullname",
					"status",
					"contact_zip4",
					"contact_zip",
					"contact_state",
					"contact_metro_city",
					"contact_address",
					"married",
					"children",
					"contact_twitter_url",
					"contact_facebook_url",
					"homeowner",
					"net_worth",
					"pages_visited",
					"company_revenue_range",
					"campaign_term",
					"company_region_code",
					"remotesessionid",
					"referrer",
					"session_date",
					"visitor_first_visit",
					"visitor_search_engine",
					"visitor_search_term",
					"company_postal_code",
					"campaign_source",
					"campaign_name",
					"campaign_medium",
					"campaign_content",
					"campaign_term",
					"contact_job_title",
					"internal_notes",
					"turn_down_comment",
					"turn_down_reason",
					"lost_reason",
					"lost_comment",
					"visualvisitor_id",
					"created_at",
					"updated_at",
					"site",
					"rooms_commission",
					"banquet_commission",
					"confirmation_id",
					"reference_id",
				];
			}
			const filteredItem = (item) =>
				Object.keys(item)
					.filter((key) => !excludedKeys.includes(key))
					.reduce((obj, key) => {
						obj[key] = item[key];
						return obj;
					}, {});
			if (this.leadType === LEAD_TYPES.INBOUND) {
				return this.leads.map((item) => filteredItem(item));
			} else {
				return this.leadsOutbound.map((item) => filteredItem(item));
			}
		},
		allTimeRangeLength() {
			return dayjs(this.lastDate).diff(this.firstDate, "day");
		},
		rangeLength() {
			return dayjs(this.dates[1]).diff(this.dates[0], "day");
		},
	},
	methods: {
		...mapActions(["logOut", "getNotification", "updateNotification"]),
		// getMinDate() {
		// 	return this.store_sites.find(
		// 		(site) => site.site_id === this.site_selected
		// 	).launch_date;
		// },

		toCapitalized(str) {
			return str.charAt(0).toUpperCase() + str.slice(1);
		},
		handleNotiPrefCancel() {
			this.notiPrefModal = false;
			this.notiPrefState = { ...this.emailPreferences };
		},
		handleNotiPrefConfirm() {
			this.emailPreferences = { ...this.notiPrefState };
			const userData = new FormData();
			userData.append("id", this.store_user.id);
			userData.append(
				"instantEmail",
				JSON.stringify(this.emailPreferences.instant)
			);
			userData.append(
				"weeklyEmail",
				JSON.stringify(this.emailPreferences.weekly)
			);
			userData.append(
				"monthlyEmail",
				JSON.stringify(this.emailPreferences.monthly)
			);

			// DISABLE CTA
			this.notiPrefCTA.disabled = true;
			this.notiPrefCTA.label = "Saving...";

			this.updateNotification(userData).then(({ status }) => {
				// UPDATE CTA LABEL
				this.notiPrefCTA.label =
					status === 200 ? "Preferences Saved" : "Error Saving";

				// HIDE MODAL
				setTimeout(() => {
					this.notiPrefModal = false;

					// RESET CTA
					setTimeout(() => {
						this.notiPrefCTA.disabled = false;
						this.notiPrefCTA.label = "Confirm Changes";
					}, 1e3);
				}, 2e3);
			});
		},
		getSiteName() {
			return this.store_sites.find(
				(site) => site.site_id === this.site_selected
			).name;
		},
		handlePropertyTypeClick(to) {
			if (to) {
				EventBus.$emit(BUS_EVENTS.PTYPE_UPDATED, {
					siteID: to.params.siteId,
					propertyType: to.params.propertyType,
					showOutbound: to.params.showOutbound,
				});
				EventBus.$emit(BUS_EVENTS.STATS_UPDATED);
				EventBus.$emit(BUS_EVENTS.STATS_O_UPDATED);
				this.$router.push(to);
			}
		},
		handleCancel() {
			this.pickerMenu = false;
			this.$router.replace({
				name: "Dashboard",
				params: { siteId: this.store_site_id },
			});
		},
		changePortal() {
			this.$emit("getApiLeads", this.dates);
		},
		getLeadsByDates() {
			this.$refs.pickerMenu.save(this.dates);
			this.$router.push({
				name: "Dashboard",
				params: {
					siteId: this.store_site_id,
					startDate: this.dates[0],
					endDate: this.dates[1],
				},
			});
			this.$emit("getApiLeads", { dates: this.dates, lead_id: null });
			EventBus.$emit(BUS_EVENTS.DATES_UPDATED, this.dates);
		},
		async logOutHandler() {
			await this.logOut();
			this.$router.push("/");
		},
		getLabelSite(property_type) {
			if (property_type == 11) return "Social Events Leads Manager"
			else if (property_type == 12) return "Weddings Leads Manager";
			else return "Meetings Leads Manager";
		},
		setDatesRange(daysCount) {
			if (!daysCount) {
				this.dates = [this.firstDate, this.lastDate];
				this.getLeadsByDates();
				// this.presetAllDatesActive = true;
			} else {
				const today = dayjs();
				const startDate = today
					.subtract(daysCount, "day")
					.format("YYYY-MM-DD");
				const endDate = today.format("YYYY-MM-DD");
				this.dates = [startDate, endDate];
				this.getLeadsByDates();
				// this.presetAllDatesActive = false;
				// this.$router.replace({ name: "Dashboard", params: { siteId: this.store_site_id, startDate: startDate, endDate: endDate } });
				// console.log('dates', this.dates);
			}
		},
		handlePresetClick(daysCount) {
			this.setDatesRange(daysCount);
		},
	},
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Spectral:wght@300&display=swap");
@import "~@/scss/colors.scss";
.Header {
	background: #fff;
	display: block;
	width: 100%;
	padding: 0 20px;
	border-bottom: 1px solid #e2e2e2;
	position: fixed;
	top: 0;
	z-index: 9;
	box-shadow: 0 0 20px rgba(#121212, 0.1);
	&_row {
		height: auto;
		min-height: 120px;
	}
	&_logo {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 230px;
		align-self: stretch;
		padding: 30px;
		border-right: 1px solid #e2e2e2;
		@media screen and (max-width: 960px) {
			flex: 0 0 auto;
			width: auto;
			padding: 20px;
			padding-left: 0;
		}
		img {
			display: block;
			width: auto;
			max-width: 100%;
			height: auto;
			@media screen and (max-width: 960px) {
				width: 40px;
			}
		}
	}
	&_portal {
		font-size: 12px;
		background: url("~@/assets/img/arrow-select1.svg") no-repeat right
			center;
		display: block;
		width: 120px;
		padding-right: 20px;
		cursor: pointer;
		appearance: none;
		&:focus {
			outline: 0;
		}
	}
	&_dates {
		.v-card {
			padding: 10px;
			@media screen and (max-width: 960px) {
				padding: 7px;
			}
		}
		&-icon {
			display: block;
		}
		&-label {
			font-size: 14px;
			display: block;
			padding-right: 10px;
			border-right: 1px solid #ebebf2;
			font-weight: 500;
			line-height: 1;
		}
		&-field {
			font-size: 12px;
			background: url("~@/assets/img/arrow-select1.svg") no-repeat right
				center;
			display: block;
			width: 170px;
			padding-right: 20px;
			cursor: pointer;
			appearance: none;
			&:focus {
				outline: 0;
			}
		}
		&-preset {
			color: $purple;
			font-size: 11px;
			display: inline-flex;
			align-items: center;
			gap: 0.6em;
			text-decoration: none;
			&:hover {
				opacity: 0.5;
			}
			&.underline {
				text-decoration: underline;
			}
			&.active {
				font-weight: 700;
				pointer-events: none;
			}
			img {
				display: block;
				width: auto;
				height: 1.3em;
			}
		}
	}

	&_download {
		font-size: 11px;
		display: inline-flex;
		align-items: center;
		gap: 0.2em;
		font-weight: 500;
		line-height: 1;
		cursor: pointer;
		&:hover {
			color: $purple;
		}
	}

	.link {
		font-size: 9px;
		color: inherit;
		display: inline-flex;
		align-items: center;
		gap: 0.6em;
		text-decoration: none;
		&:hover {
			opacity: 0.5;
		}
		&.underline {
			text-decoration: underline;
		}
		&.active {
			font-weight: 700;
		}
		img {
			display: block;
			width: auto;
			height: 1.3em;
		}
	}
}

hr.vr {
	background: #c2c2c2;
	width: 1px;
	height: 20px;
	margin-right: -8px; //REDUCE DEFAULT GAP
	border: 0;
}

#app .Header_title {
	&.text-h4 {
		font: 300 32px / 1 "Spectral", serif !important;
		color: $purple;
		letter-spacing: -0.04em !important;
		@media screen and (max-width: 960px) {
			display: none;
		}
	}
}
.Header_name {
	font-size: 13px;
	color: #a0a0a0;
	display: block;
	text-transform: uppercase;
}

/deep/ .v-date-picker-header {
	.v-icon {
		opacity: 1;
		&::after {
			display: none;
		}
		&.mdi-chevron-left {
			background: url("~@/assets/img/arrow-left2.svg") no-repeat center
				center;
		}
		&.mdi-chevron-right {
			background: url("~@/assets/img/arrow-right2.svg") no-repeat center
				center;
		}
	}
}

/deep/ .v-list {
	padding: 5px;
	.v-btn {
		border-radius: 0 0 5px 5px;
	}
}
/deep/ .v-list-item {
	max-width: 150px;
	min-height: 0;
	padding: 0;
	border-top: 1px solid #e2e2e2;
	&:first-child {
		border-top: 0;
	}
	.link {
		font-size: 12px;
		background: url("~@/assets/img/arrow-right3.svg") no-repeat right 5px
			center;
		color: inherit;
		width: 100%;
		padding: 10px;
		padding-right: 20px;
		line-height: 1.2;
		text-decoration: none;
		&:hover {
			background-color: #f6f6f6;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue